import { DeckData, SeatDetail } from '@/src/types/itinerary'
import { getSeatColor } from '@/src/utils/itinerary/addons'
import { useEffect, useRef } from 'react'
import Aircraft from './aircraft'

const AircraftWrapper = ({
    seatData,
    selectedSeatOptions,
    handleAddSeat,
    handleRemoveSeat,
    formatCurrency
}: {
    seatData: DeckData
    selectedSeatOptions: Partial<SeatDetail>[]
    handleAddSeat: (seat: SeatDetail) => void
    handleRemoveSeat: (seat: SeatDetail) => void
    formatCurrency: (price: number) => string
}) => {
    const { totalColumns, rows, seatPriceMap, seatColumns } = seatData || {}

    const seatSize = 30
    const seatGap = 8
    const rowIdBoxWidth = 36
    const ratio = 0.8

    // 2 extra spacing for aircraft head and tail image.
    const craftWidth = 2 + totalColumns * seatSize + (totalColumns - 1) * seatGap + 2 * rowIdBoxWidth
    const headAndTailHeight = craftWidth * ratio
    const scrollPosition = craftWidth * (ratio - 0.05)

    const scrollContainerRef = useRef<HTMLDivElement>(null)
    const columnHeadersRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (scrollContainerRef.current && columnHeadersRef.current) {
            if (scrollContainerRef.current && columnHeadersRef.current) {
                scrollContainerRef.current.scrollTop = scrollPosition
            }
        }
    }, [])

    return (
        <Aircraft
            columnHeadersRef={columnHeadersRef}
            scrollContainerRef={scrollContainerRef}
            craftWidth={craftWidth}
            headAndTailHeight={headAndTailHeight}
            seatColumns={seatColumns}
            rows={rows}
            totalColumns={totalColumns}
            selectedSeatOptions={selectedSeatOptions}
            handleAddSeat={handleAddSeat}
            handleRemoveSeat={handleRemoveSeat}
            getSeatColor={(price: number) => getSeatColor(price, seatPriceMap)}
            formatCurrency={formatCurrency}
        />
    )
}

export default AircraftWrapper
